<app-toolbar></app-toolbar>
<div class="auth-container" style="background: none; height: 83.5vh; overflow: unset !important;">

    <div class="container">
        <div>
            <span>
                <b>ÚLTIMA ACTUALIZACIÓN:</b> 28 de Junio de 2021
                <br><br>
                Comuníquese con nosotros si necesita una copia de esta notificación a partir de una fecha en particular.
                <br><br>
                <b>FECHA DE ENTRADA EN VIGENCIA:</b> 15 de mayo de 2018
            </span>
        </div>
        <div class="frequent-questions-title">
            <span class="title">
                Aviso de privacidad
            </span>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="text">
                Este “Aviso de privacidad” describe las prácticas del Fiserv, Inc., incluidas y sus subsidiarias y
                afiliadas
                (colectivamente, “Fiserv”, “nosotros” o “nuestro”), y los derechos y las opciones disponibles para las
                personas
                respecto a los datos personales. Datos personales hace referencia a cualquier información relacionada
                con un
                individuo identificable.<br><br>
                Fiserv puede proporcionar avisos de privacidad independientes que se apliquen a productos o servicios
                específicos que ofrecemos, en cuyo caso no se aplica este Aviso de privacidad. En los casos que se
                aplique
                este Aviso de privacidad, Fiserv puede proporcionar notificaciones de privacidad adicionales o
                complementarias
                a las personas en el momento en que recopilamos sus datos, las cuales regirán la manera en que
                procesamos
                la información proporcionada en ese momento. Podemos alterar esta Declaración de privacidad conforme sea
                necesario para ciertos productos y servicios y cumplir con las leyes o reglamentaciones locales en todo
                el
                mundo, como al proporcionar información complementaria en ciertos países. Este Aviso de privacidad no se
                aplica al procesamiento por parte de Fiserv de los datos personales de su personal, tales como empleados
                y
                contratistas.<br><br>
                Proporcionamos información importante aquí para individuos ubicados en los Estados Miembros de la Unión
                Europea, países en el <b><a style="color: black !important;"
                        href="https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Glossary:European_Economic_Area_(EEA))"
                        target="_blank">Espacio Económico Europeo</a></b>, el Reino Unido y Suiza (en conjunto, “Europa”
                o “Europeo”).
            </span>
        </div>

        <div class="questions-container" style="padding-top: 30px !important;">
            <div class="text">
                <span class="text">
                    <u><b>Índice</b></u>
                </span><br><br>
                <span class="text">
                    <span class="text">
                        1. Los datos personales que recopilamos
                    </span>
                    <span class="text">
                        2. Cómo usamos sus datos personales
                    </span>
                    <span class="text">
                        3. Cómo compartimos sus datos personales
                    </span>
                    <span class="text">
                        4. Sus derechos y opciones
                    </span>
                    <span class="text">
                        5. Transferencias internacionales
                    </span>
                    <span class="text">
                        6. Cómo mantenemos sus datos seguros
                    </span>
                    <span class="text">
                        7. Este sitio web puede tener vínculos a otros sitios web
                    </span>
                    <span class="text">
                        8. Información adicional para usuarios europeos
                    </span>
                    <span class="text">
                        9. Cambios a este Aviso de privacidad
                    </span>
                    <span class="text">
                        10. Contáctenos
                    </span>
                    <b>1. Los datos personales que recopilamos</b><br><br>
                    Recopilamos datos personales sobre personas de diversas fuentes descritas a continuación. Según
                    corresponda, le indicaremos si los individuos deben proporcionarnos datos personales y por qué, así
                    como las
                    consecuencias de no hacerlo.
                    <br>
                    <b>Información que recopilamos directamente de las personas y las partes con las que hacemos
                        negocios</b>
                    <br><br>
                    Podemos recopilar datos personales directamente de las personas y las partes con las que hacemos
                    negocios,
                    incluyendo clientes potenciales. Estos pueden incluir a las partes que interactúan con nosotros
                    directamente
                    (como las personas que descargan nuestras aplicaciones móviles o solicitantes de empleo), las partes
                    a las que
                    proporcionamos bienes o servicios (como clientes, bancos o instituciones financieras, comerciantes e
                    individuos) (en conjunto, <b>“clientes”</b>), partes que nos brindan servicios (como proveedores)
                    (en conjunto,
                    <b>“proveedores de servicios”</b>), y otras partes con las que ofrecemos o proporcionamos productos
                    y servicios
                    (como organizaciones de ventas independientes) (en conjunto, <b>“socios”</b>).<br><br>
                    Podemos recopilar información de estas partes en una variedad de contextos, como al completar uno de
                    nuestros formularios en línea, hacer una solicitud para uno de nuestros productos o servicios,
                    interactuar con
                    nosotros en las redes sociales o corresponder con nosotros. Los tipos de información que obtenemos
                    en estos
                    contextos incluyen:

                    <ul>
                        <li>Información de contacto de la entidad comercial y de su personal que interactúa con
                            nosotros, como el
                            nombre, el cargo, la dirección, el número de teléfono y la dirección de correo electrónico.
                        </li>
                        <li>Información de perfil, como el nombre de usuario y la contraseña que una persona puede
                            establecer en
                            uno de nuestros sitios web o aplicaciones móviles, junto con cualquier otra información que
                            un individuo
                            ingresa en su perfil de cuenta.
                        </li>
                        <li>Detalles demográficos, como la fecha de nacimiento, el país de ciudadanía y/o el país de
                            residencia.</li>
                        <li>Información sobre la afiliación de individuos con una entidad legal, como el rol de un
                            individuo, y si él o
                            ella es un propietario beneficioso o firmante autorizado.</li>
                        <li>Números de identificación emitidos por el gobierno (en la medida permitida por la ley
                            aplicable), como
                            un número de identificación nacional (p. ej., número de seguro social, número de
                            identificación fiscal o
                            número de pasaporte), número de identificación estatal o local (p. ej., una licencia de
                            conducir u otro
                            número de identificación emitido por el gobierno), y una copia de su tarjeta de
                            identificación emitida por
                            el gobierno.</li>
                        <li>Comentarios y correspondencia, como la información que usted proporciona cuando nos solicita
                            información, recibe atención al cliente o corresponde con nosotros, incluyendo la
                            interacción con
                            nuestras páginas en sitios o servicios de redes sociales en línea.
                        </li>
                        <li>Información de la cuenta bancaria, información de la tarjeta o información de la cuenta
                            bancaria. </li>
                        <li>
                            Información sobre el comercio, como el nombre del comerciante, la identificación del
                            comerciante y el
                            giro comercial, la ubicación del comerciante donde se produjo una transacción y la
                            información sobre las
                            transacciones procesadas por el comerciante, incluyendo el volumen de la transacción, la
                            velocidad, los
                            montos, los tipos de productos o servicios vendidos y los índices de contracargos.
                        </li>
                        <li>
                            Información relacionada con el uso de productos o servicios de Fiserv, como información de
                            cuenta,
                            umbrales de gasto, actividad de gastos y patrones, e información sobre las transacciones que
                            procesamos.
                        </li>
                        <li>
                            Información sobre la ubicación geográfica precisa, si autoriza que nuestra aplicación móvil
                            acceda a su
                            ubicación.
                        </li>
                        <li>
                            Información de marketing, como sus preferencias para recibir comunicaciones de marketing y
                            detalles
                            sobre cómo interactúa con nuestras comunicaciones.
                        </li>
                        <li>
                            Otra información suministrada por los solicitantes de empleo, tales como credenciales
                            profesionales y
                            habilidades, historial educativo y laboral, y otra información del tipo incluido en un
                            currículum vitae o una
                            hoja de vida.
                        </li>
                    </ul>

                    <b>Información que recopilamos sobre personas que no interactúan con nosotros directamente</b>
                    <br><br>
                    Podemos recibir datos personales sobre personas que no interactúan con nosotros directamente. Por
                    ejemplo,
                    nuestros clientes, proveedores de servicios y socios pueden proporcionarnos información sobre
                    personas que
                    no sean ellos mismos al usar nuestros productos o servicios. Además, debido a la naturaleza única de
                    los
                    negocios de Fiserv, en muchos casos, Fiserv obtiene datos personales de otros participantes de una
                    cadena
                    de procesamiento de transacciones, como asociaciones de tarjetas y operadores de redes de débito, y
                    sus
                    miembros. Los tipos de información que recibimos sobre terceros incluyen:
                    <br>
                    <ul>
                        <li>
                            <b>Información sobre el personal de nuestros clientes, proveedores de servicios o
                                socios</b>, como la
                            información de contacto comercial que nuestros clientes, proveedores de servicios o socios
                            nos
                            proporcionan en el contexto de nuestras relaciones contractuales con ellos
                        </li>
                        <li>
                            <b>Información sobre posibles candidatos para un puesto</b>, como cuando un reclutador se
                            comunica
                            con nosotros sobre una persona que puede convertirse en candidata para un puesto en Fiserv
                        </li>
                        <li><b>Información sobre los clientes de nuestros clientes:</b> nuestros clientes nos envían o
                            nos permiten
                            recopilar en el contexto de los servicios que presta Fiserv, como información relacionada
                            con
                            transacciones financieras iniciadas por el cliente, registros de cuentas y, en algunos
                            casos, información
                            necesaria para verificar la identidad del cliente y los detalles de los productos o
                            servicios adquiridos, y
                            conforme se indique de otra manera en un aviso de privacidad específico aplicable para un
                            producto o
                            servicio de Fiserv. Cuando nuestra tecnología se incorpora a la aplicación móvil o el sitio
                            web de un
                            comerciante, también podemos recopilar automáticamente cierta información del tipo descrito
                            en la
                            sección a continuación titulada “Información recopilada a través de medios automatizados”.
                        </li>
                        <li><b>Información obtenida al procesar</b> transacciones, como información sobre transacciones
                            de pago</li>
                    </ul>
                    <br><br>
                    <b>
                        Información que recopilamos de fuentes privadas y de acceso público
                    </b>
                    <br><br>
                    Nosotros y nuestros proveedores de servicios podemos recopilar información sobre personas que tienen
                    sus
                    datos en fuentes públicas, incluso mediante la búsqueda en listas gubernamentales de acceso público
                    de
                    personas restringidas o autorizadas (como la listas especializadas de personas bloqueadas), bases de
                    datos
                    de registros públicos (como registros de empresas y presentaciones reglamentarias), y mediante la
                    búsqueda
                    en medios de comunicación y el Internet. Nosotros y nuestros proveedores de verificación externos
                    también
                    podemos recopilar información de fuentes privadas o disponibles comercialmente, por ejemplo
                    solicitando
                    información de sociedades de información crediticia y prevención de fraude, en la medida permitida
                    bajo la ley
                    aplicable.
                    <br><br>
                    También podemos mantener páginas para nuestra empresa y nuestros productos y servicios en una
                    variedad
                    de plataformas de terceros, como LinkedIn, Facebook, Twitter, Google+, YouTube, Instagram y otros
                    servicios
                    de redes sociales. Cuando interactúa con nuestras páginas en esas plataformas de terceros, la
                    política de
                    privacidad del tercero regirá sus interacciones en la plataforma pertinente. Si la plataforma del
                    tercero nos
                    proporciona información sobre nuestras páginas en esas plataformas o sus interacciones con estas
                    páginas,
                    trataremos esa información de acuerdo con este Aviso de privacidad.
                    <br><br>
                    <b>Información recopilada a través de medios automatizados</b>
                    <br><br>
                    Cuando accede a nuestros sitios web o utiliza nuestras aplicaciones móviles, nosotros, nuestros
                    proveedores
                    de servicios y nuestros socios pueden recopilar automáticamente información sobre usted, su
                    computadora o dispositivo móvil,
                    y la actividad en nuestros sitios web o aplicaciones móviles. Típicamente, esta información
                    incluye el tipo y número de versión, el fabricante y el modelo del sistema operativo, el
                    identificador del dispositivo
                    (como el ID de publicidad de Google o el ID de publicidad de Apple), el tipo de navegador, la
                    resolución de la
                    pantalla, la dirección IP de su computadora o dispositivo móvil, el sitio web que visitó antes de
                    navegar en
                    nuestro sitio web, la información general de ubicación, como la ciudad, estado o área geográfica e
                    información
                    sobre su uso y acciones en nuestros sitios web o aplicaciones móviles, como las páginas o pantallas
                    a las que
                    accedió, el tiempo que pasó en una página o pantalla, las rutas de navegación entre las páginas o
                    pantallas, la
                    información sobre su actividad en una página o pantalla, los tiempos de acceso y la duración del
                    acceso. Ciertos
                    productos o servicios que proporcionamos o que los comerciantes pueden incorporar en sus sitios web
                    o
                    aplicaciones móviles pueden recopilar automáticamente información adicional, como se puede describir
                    más
                    detalladamente en un aviso de privacidad independiente.
                    <br><br>
                    Nuestros proveedores de servicios y socios comerciales podemos recopilar este tipo de información
                    con el
                    tiempo y en sitios web de terceros. Esta información se recopila a través de diversos mecanismos,
                    como por
                    ejemplo, a través de cookies, balizas web, scripts incrustados, a través de nuestras aplicaciones
                    móviles y
                    tecnologías similares. Este tipo de información también puede recopilarse cuando usted lee nuestros
                    correos
                    electrónicos habilitados para HTML. Para más detalles, consulte nuestr
                    <b><a style="color: black !important;"
                            href="https://merchants.fiserv.com/en-us/privacy/cookies/?utm_source=firstdataus"
                            target="_blank"> Divulgación de cookies.</a></b>
                    Puede optar
                    por deshabilitar las cookies o excluirse del uso de su comportamiento de navegación para fines de
                    publicidad
                    dirigida. Para obtener instrucciones de exclusión, revise la parte de “Publicidad dirigida en línea”
                    de la sección
                    “Sus opciones” de este Aviso de privacidad.
                    <br><br>
                    <b>Datos personales confidenciales</b>
                    <br><br>
                    En circunstancias limitadas y cuando lo permita la ley, podremos solicitar datos biométricos para
                    confirmar su
                    identidad, por ejemplo, cuando usamos sus huellas dactilares para autenticar un pago. En algunas
                    circunstancias, podemos recopilar información que puede revelar información médica o de salud, por
                    ejemplo,
                    cuando procesamos transacciones en instalaciones médicas o de salud, o en farmacias. En el contexto
                    del
                    procesamiento de solicitudes de empleo, también podemos solicitar información sensible, como el
                    origen racial
                    o étnico o información sobre la discapacidad, cuando así lo requiera o permita la ley del país en el
                    que está
                    solicitando empleo.
                    <br><br>
                    Más allá de estos contextos o de otra manera cuando lo solicitemos específicamente, le pedimos que
                    no nos
                    proporcione ningún dato personal sensible (es decir, información que revele el origen racial o
                    étnico, opiniones
                    políticas, creencias religiosas o filosóficas, la afiliación sindical, información genética, de
                    salud o biométrica,
                    información sobre la vida sexual o la orientación sexual, o condenas o delitos penales) a través de
                    nuestros
                    sitios web o aplicaciones móviles, o de otra manera.
                    <br><br>
                    <b>2. Cómo usamos sus datos personales</b>
                    <br><br>
                    Usamos sus datos personales para fines de:
                    <br><br>
                    <b>Proporcionar nuestros productos y servicios, lo que incluye:</b>
                    <br><br>
                    <ul>
                        <li>
                            Operar, evaluar, mantener, mejorar y proporcionar las características y la funcionalidad de
                            nuestros
                            productos y servicios
                        </li>
                        <li>
                            Tramitar una transacción de pago iniciada por usted (ya sea con nosotros o con nuestro
                            cliente)
                        </li>
                        <li>Gestionar nuestra relación con usted o con su empresa
                        </li>
                        <li>Cumplir nuestras obligaciones y ejercer nuestros derechos en virtud de nuestro acuerdo con
                            usted o con
                            su empresa</li>
                        <li>
                            Comunicarnos con usted acerca de su cuenta con nosotros, si tiene una, incluso enviándole
                            correos
                            electrónicos o mensajes relacionados con el servicio (p. ej., mensajes relativos a la
                            verificación de la
                            cuenta, cambios o actualizaciones de la funcionalidad de nuestros productos o servicios,
                            avisos y alertas
                            técnicos y de seguridad, y mensajes de asistencia y administrativos)
                        </li>
                        <li>
                            Personalizar la manera en que proporcionamos nuestros productos y servicios
                        </li>
                        <li>
                            Controlar el fraude o el lavado de dinero, o gestionar nuestros riesgos o los riesgos de
                            nuestros clientes
                        </li>
                        <li>
                            Administrar y proteger nuestros negocios
                        </li>
                        <li>
                            Proporcionar asistencia y mantenimiento para nuestros productos y servicios, incluyendo
                            responder a
                            sus solicitudes, preguntas y comentarios relacionados con el servicio
                        </li>
                    </ul>
                    <br><br>
                    <b>Para fines de investigación y desarrollo
                    </b>
                    <br><br>
                    Utilizamos la información que recopilamos para nuestros propios fines de investigación y desarrollo,
                    lo que
                    incluye:
                    <br><br>
                    <ul>
                        <li>
                            Desarrollar o mejorar nuestros productos y servicios
                        </li>
                        <li>
                            Desarrollar y crear análisis e informes relacionados, por ejemplo, en relación con las
                            tendencias del
                            sector y el fraude
                        </li>
                    </ul>
                    <br><br>
                    <b>
                        Marketing
                    </b>
                    <br><br>
                    Podemos usar sus datos personales para darnos una idea de los productos o los servicios que pensamos
                    que
                    podría querer o necesitar, o que podrían interesarle.
                    <br><br>
                    Podemos contactarlo con comunicaciones de marketing utilizando los datos personales que nos ha
                    proporcionado si ha expresado activamente su interés en hacer una compra o si nos ha comprado algún
                    producto o servicio y, en cualquier caso, no ha cancelado la opción de recibir ese material de
                    marketing, en la
                    medida permitida por la ley aplicable.
                    <br><br>
                    Cuando lo exija la ley, obtendremos su consentimiento expreso de inclusión antes de compartir sus
                    datos
                    personales con cualquier empresa que no pertenezca al Grupo de Fiserv por motivos de marketing.
                    Usted puede, en cualquier momento, pedirnos que dejemos de enviarle mensajes de marketing, para
                    ello, puede
                    comunicarse con nosotros a través de los detalles indicados en la sección Contáctenos o hacer clic
                    en el enlace
                    de exclusión incluido en cada mensaje de marketing.
                    <br><br>
                    Si decide dejar de recibir nuestros mensajes de marketing, seguiremos realizando nuestras demás
                    actividades
                    relevantes que implican el uso de sus datos personales, incluido el envío de mensajes que no sean de
                    marketing.
                    <br><br>
                    <b>
                        Gestionar nuestro reclutamiento y procesar las solicitudes de empleo
                    </b>
                    <br><br>
                    Procesamos los datos personales, como la información que se nos envía en una solicitud de empleo,
                    para
                    facilitar nuestras actividades de reclutamiento y procesar las solicitudes de empleo, por ejemplo,
                    evaluar a un
                    candidato para una actividad laboral y monitorear las estadísticas de reclutamiento.
                    <br><br>
                    <b>
                        Cumplimiento de la ley
                    </b>
                    <br><br>
                    Utilizamos sus datos personales según lo creamos necesario o apropiado para cumplir con las leyes
                    aplicables,
                    las solicitudes legítimas y el proceso legal, como para responder a notificaciones o solicitudes de
                    autoridades
                    gubernamentales.
                    <br><br>
                    <b>
                        Cumplimiento, prevención del fraude y seguridad
                    </b>
                    <br><br>
                    Utilizamos sus datos personales según creamos necesario o apropiado para (a) hacer cumplir los
                    términos y
                    condiciones que rigen nuestros productos y servicios; (b) proteger nuestros derechos, nuestra
                    privacidad,
                    seguridad o propiedad, o bien, los de usted u otras personas; y (c) investigar e impedir actividades
                    fraudulentas,
                    perjudiciales, no autorizadas, poco éticas o ilegales, y protegerlo de este tipo de actividades.
                    <br><br>
                    <b>
                        Cumplimiento, prevención del fraude y seguridad
                    </b>
                    <br><br>
                    En algunas jurisdicciones, la ley aplicable puede exigirnos que solicitemos su consentimiento para
                    utilizar sus
                    datos personales en determinados contextos, por ejemplo, cuando utilizamos determinadas cookies o
                    tecnologías similares o nos gustaría enviarle ciertos mensajes de marketing. Si solicitamos su
                    consentimiento
                    para utilizar sus datos personales, tiene derecho a retirar su consentimiento en cualquier momento
                    en la forma
                    indicada cuando solicitamos el consentimiento o contactándonos. Si ha dado su consentimiento para
                    recibir
                    comunicaciones de marketing de nuestros socios externos, puede retirar su consentimiento
                    comunicándose con
                    dichos socios directamente.
                    <br><br>
                    <b>
                        Para crear datos anónimos
                    </b>
                    <br><br>
                    Podemos crear datos anónimos de sus datos personales y otras personas cuyos datos personales
                    recopilamos.
                    Convertimos los datos personales en datos anónimos excluyendo la información que hace que los datos
                    sean
                    identificables personalmente para usted, y usamos esos datos anónimos para nuestros fines
                    comerciales
                    legítimos.
                    <br><br>
                    <b>
                        3. Cómo compartimos sus datos personales
                    </b>
                    <br><br>
                    <b>
                        Compañías del grupo Fiserv
                    </b>
                    <br><br>
                    Podemos divulgar sus datos personales a nuestras subsidiarias y filiales corporativas para fines
                    acordes con
                    este Aviso de privacidad.
                    <br><br>
                    <b>
                        Proveedores de servicios
                    </b>
                    <br><br>
                    Podemos emplear empresas y personas externas para administrar y prestar servicios en nuestro nombre
                    (como
                    empresas que brindan atención al cliente, empresas que contratamos para administrar, mantener y
                    desarrollar
                    nuestro sitio web, aplicaciones móviles y sistemas de TI, y empresas que nos ayudan a procesar los
                    pagos).
                    Estos terceros pueden usar su información únicamente según lo indique Fiserv y de manera coherente
                    con este
                    Aviso de privacidad, y tienen prohibido usar o divulgar su información para cualquier otro fin.
                    <br><br>
                    <b>
                        Nuestros clientes
                    </b>
                    <br><br>
                    Cuando Fiserv presta servicios a sus clientes, puede compartir datos personales con esas entidades.
                    Por
                    ejemplo, Fiserv puede recopilar información sobre los clientes de un cliente o en nombre del
                    cliente, por ejemplo,
                    cuando Fiserv procesa transacciones de pago, y Fiserv puede proporcionar datos personales sobre esos
                    clientes de vuelta al cliente. No nos hacemos responsables de las prácticas de privacidad de
                    nuestros clientes.
                    <br><br>
                    <b>
                        Participantes en la cadena de procesamiento de transacciones
                    </b>
                    <br><br>
                    Fiserv comparte datos personales con empresas de la cadena de procesamiento de transacciones en
                    relación
                    con el procesamiento de una transacción de pago, como comerciantes, bancos u otras asociaciones de
                    tarjetas
                    o emisores de tarjetas, operadores de redes de débito y sus miembros.
                    <br><br>
                    <b>
                        Sociedades de información crediticia, protección contra fraudes, gestión de riesgos y
                        verificación de
                        identidad
                    </b>
                    <br><br>
                    Fiserv comparte los datos personales con sociedades de información crediticia, protección contra
                    fraudes,
                    gestión de riesgos y verificación de identidad para ayudar a protegerse, detectar y responder al
                    fraude o al
                    lavado de dinero, y/o gestionar nuestro riesgo o el de nuestros clientes, y asegurarnos que
                    cumplamos con los
                    requisitos contractuales, legales o reglamentarios.
                    <br><br>
                    <b>
                        Asesores profesionales
                    </b>
                    <br><br>
                    Podemos divulgar sus datos personales a asesores profesionales, como abogados, representantes
                    bancarios,
                    auditores y aseguradores, cuando sea necesario en el curso de los servicios profesionales que nos
                    prestan.
                    <br><br>
                    <b>
                        Cumplimiento de las leyes y aplicación de la ley; protección y seguridad
                    </b>
                    <br><br>
                    Fiserv puede divulgar información sobre usted a funcionarios del gobierno o encargados del
                    cumplimiento de la
                    ley (incluyendo las autoridades de impuestos), o bien, a partes privadas, según lo exija la ley, y
                    puede divulgar
                    y usar dicha información como creamos necesario o apropiado para (a) cumplir con las leyes vigentes
                    y las
                    solicitudes legítimas y los procesos legales, como responder a notificaciones o solicitudes de
                    autoridades
                    gubernamentales; (b) aplicar los términos y las condiciones que rigen nuestros productos y
                    servicios;
                    (c) proteger nuestros derechos, nuestra privacidad, seguridad o propiedad, o bien, los de usted o
                    los de otras
                    personas; e (d) investigar e impedir actividades fraudulentas, perjudiciales, no autorizadas, poco
                    éticas o
                    ilegales, y protegerlo de este tipo de actividades.
                    <br><br>
                    <b>
                        Transferencias comerciales
                    </b>
                    <br><br>
                    Fiserv puede vender o transferir una parte o la totalidad de sus negocios o activos, incluyendo sus
                    datos
                    personales, en relación con una transacción comercial (o una posible transacción comercial), como
                    una fusión,
                    una consolidación, una adquisición, una reorganización o una venta de activos, o en caso de quiebra,
                    en cuyo
                    caso realizaremos los esfuerzos razonables para exigir al destinatario que cumpla este Aviso de
                    privacidad.
                    <br><br>
                    <b>
                        A otras partes con su permiso o para cumplir un contrato que tienen con usted
                    </b>
                    <br><br>
                    Fiserv puede transferir sus datos personales a cualquier tercero que no esté cubierto por otras
                    categorías
                    mencionadas anteriormente cuando nos haya otorgado permiso para hacerlo, o con quien haya celebrado
                    un
                    contrato cuando necesitemos transferir sus datos personales a esa parte con el fin de cumplir ese
                    contrato.
                    <br><br>
                    <b>
                        4. Sus derechos y opciones
                    </b>
                    <br><br>
                    En esta sección, describimos los derechos y las opciones disponibles para todos los usuarios. Los
                    usuarios que
                    se encuentran en Europa pueden leer información adicional sobre sus derechos a continuación.
                    <br><br>
                    <b>
                        Comunicaciones de marketin
                    </b>
                    <br><br>
                    Usted puede, en cualquier momento, pedirnos que dejemos de enviarle mensajes de marketing en
                    cualquier
                    momento contactándonos o haciendo clic en el enlace de exclusión incluido en cada mensaje de
                    marketing.
                    Puede seguir recibiendo mensajes relacionados con el servicio y otros que no se relacionen con temas
                    de
                    marketing.
                    <br><br>
                    <b>
                        Publicidad dirigida en línea
                    </b>
                    <br><br>
                    Es posible que algunos de los socios comerciales que reúnen información sobre las actividades de los
                    usuarios
                    en nuestros sitios web y en nuestras aplicaciones móviles sean miembros de organizaciones o
                    programas que
                    le ofrecen a las personas opciones en función de su comportamiento de navegación o uso de la
                    aplicación móvil
                    a los fines de la publicidad dirigida.
                    <br><br>
                    Los usuarios pueden excluirse de recibir publicidad dirigida en sitios web a través de miembros
                    participantes de
                    las siguientes organizaciones o programas:
                    <br><br>
                    <ul>
                        <li>
                            <b><a style="color: black !important;" href="https://optout.networkadvertising.org/?c=1"
                                    target="_blank">Network Advertising Initiative
                                </a></b>(EE. UU.)
                        </li>
                        <li>
                            <b><a style="color: black !important;" href="https://optout.aboutads.info/?c=2&lang=ES"
                                    target="_blank">
                                    Digital Advertising Alliance
                                </a></b>(EE. UU.)
                        </li>
                        <li>
                            <b><a style="color: black !important;" href="https://youronlinechoices.eu/" target="_blank">
                                    European Interactive Digital Advertising Alliance
                                </a></b>(Europa)
                        </li>
                        <li>
                            <b><a style="color: black !important;" href="https://youradchoices.ca/en/tools"
                                    target="_blank">
                                    Digital Advertising Alliance of Canada
                                </a></b>(Canadá)
                        </li>
                        <li>
                            <b><a style="color: black !important;" href="https://youronlinechoices.com.au/"
                                    target="_blank">
                                    Australian Digital Advertising Alliance
                                </a></b>(Australia)
                        </li>
                        <li>
                            <b><a style="color: black !important;" href="https://youradchoices.ca/en/tools"
                                    target="_blank">
                                    Data Driven Advertising Initiative
                                </a></b>(Japón)
                        </li>
                    </ul>
                    <br><br>
                    Los usuarios de aplicaciones móviles pueden dejar de recibir publicidad dirigida a través de los
                    miembros que
                    participen en Digital Advertising Alliance, al instalar la aplicación móvil AppChoices, que se
                    encuentra
                    disponible aquí, y al seleccionar las opciones del usuario. Además, es posible que la configuración
                    de su
                    dispositivo móvil disponga de una función para limitar nuestra capacidad, o la de nuestros socios,
                    para participar
                    en el seguimiento de publicidades o en publicidades dirigidas con el identificador de publicidad de
                    Google o el
                    identificador de publicidad de Apple asociados a su dispositivo móvil.
                    <br><br>
                    Tenga en cuenta que también trabajamos con empresas que ofrecen sus propios mecanismos de exclusión
                    y
                    que es posible que no participen en los mecanismos de exclusión cuyos enlaces mostramos
                    anteriormente.
                    <br><br>
                    Si decide dejar de recibir publicidades dirigidas, aún seguirá viendo publicidades en línea, pero es
                    posible que
                    no sean relevantes para usted. Incluso si decide excluirse, no todas las empresas que utilizan
                    segmentación
                    por comportamiento están incluidas en esta lista, por lo que aún puede recibir algunas cookies y
                    publicidades
                    personalizadas de las empresas que no están en la lista.
                    <br><br>
                    <b>
                        Señales de no rastrear
                    </b>
                    <br><br>
                    Es posible que algunos navegadores de Internet estén configurados para enviar señales de “No
                    rastrear” a los
                    servicios en línea que visita. Actualmente, no respondemos a las señales de no rastrear. Para
                    obtener más
                    información sobre la configuración de “No rastrear”, visiteb><b><a style="color: black !important;"
                            href="https://www.allaboutdnt.com" target="_blank">
                            https://www.allaboutdnt.com
                        </a></b>.
                    <br><br>
                    <b>
                        Elección de no proporcionar sus datos personales
                    </b>
                    <br><br>
                    Cuando nosotros le solicitemos datos personales directamente, usted no tiene la obligación de
                    proporcionarlos.
                    Si decide no proporcionar la información solicitada, en algunas circunstancias, es posible que
                    nosotros o
                    nuestros clientes, no podamos brindarle productos o servicios. Por ejemplo, es posible que no
                    podamos
                    procesar su transacción.
                    <br><br>
                    <b>
                        Acceder, modificar o eliminar su información
                    </b>
                    <br><br>
                    En algunas jurisdicciones, la ley aplicable puede establecer un derecho para que las personas
                    accedan,
                    modifiquen o eliminen sus datos personales. Puede contactarnos directamente para solicitar
                    acceso,modificar
                    o eliminar su información. Es posible que no podamos proporcionar acceso a, modificar ni eliminar su
                    información en todas las circunstancias.
                    <br><br>
                    <b>
                        Quejas
                    </b>
                    <br><br>
                    Si tiene una queja sobre el manejo de sus datos personales, puede comunicarse con nuestro encargado
                    de la
                    protección de datos utilizando la información de contacto a continuación. Solicitamos que la queja
                    sea por
                    escrito. Proporcione detalles sobre su inquietud o queja para que nuestro encargado de la protección
                    de datos
                    pueda investigarla. Tomaremos las medidas apropiadas en respuesta a su queja, lo que puede incluir
                    la
                    realización de discusiones internas con los representantes comerciales relevantes. Podemos
                    comunicarnos con
                    usted para obtener detalles adicionales o aclaraciones sobre su inquietud o queja. Nos comunicaremos
                    con
                    usted para informarle sobre nuestra respuesta a su queja. También puede tener derecho a presentar
                    una queja
                    ante la entidad reguladora local.
                    <br><br>
                    <b>
                        Quejas
                    </b>
                    <br><br>
                    <b>
                        5. Transferencias internacionales
                    </b>
                    <br><br>
                    Fiserv tiene sede en los Estados Unidos y mantiene oficinas y cuenta con proveedores de servicios en
                    otros
                    países, como los países enumerados aquí. Sus datos personales pueden transferirse a los Estados
                    Unidos o a
                    otros lugares fuera de su estado, provincia o país, o bien, a otra jurisdicción gubernamental en las
                    que nosotros
                    o nuestros proveedores de servicios mantienen oficinas y donde es posible que las leyes de
                    privacidad no
                    brinden el grado de protección que brindan aquellas que corresponden a su jurisdicción. Si
                    realizamos dicha
                    transferencia, solicitamos que los destinatarios de sus datos personales proporcionen seguridad y
                    protección
                    de los datos de acuerdo con la ley aplicable.
                    Los usuarios europeos deben leer la información importante proporcionada aquí sobre la transferencia
                    de datos
                    personales fuera de Europa.
                    <br><br>
                    <b>
                        6. Cómo mantenemos sus datos seguros
                    </b>
                    <br><br>
                    Hemos implementado medidas de seguridad adecuadas para evitar que sus datos personales se pierdan
                    accidentalmente, se utilicen o se acceda a ellos de manera no autorizada, se modifiquen o se
                    divulguen.
                    Además, limitamos el acceso a sus datos personales a aquellos empleados, agentes, contratistas y
                    otros
                    terceros que tengan una necesidad comercial de conocerlos. Solo procesarán sus datos personales
                    según
                    nuestras instrucciones y están sujetos a una obligación de confidencialidad.
                    Mantenemos el cumplimiento anual de la Norma de Seguridad de Datos para la Industria de Tarjetas de
                    Pago
                    (Payment Card Industry Data Security Standard, PCI DSS) global adoptada por las marcas de tarjetas
                    para
                    todas las empresas que procesan, almacenan o transmiten datos de titulares de tarjetas.
                    Hemos implementado procedimientos para abordar cualquier sospecha de incumplimiento de los datos
                    personales, y le informaremos a usted y a cualquier regulador correspondiente sobre un
                    incumplimiento si
                    tenemos la obligación legal de hacerlo.
                    <br><br>
                    <b>
                        7. Este sitio web puede tener vínculos a otros sitios web
                    </b>
                    <br><br>
                    También podemos incluir vínculos a sitios web, aplicaciones móviles y otros contenidos de terceros.
                    Fiserv no
                    es responsable de las prácticas de privacidad de ningún tercero, y esta notificación sobre prácticas
                    de
                    confidencialidad no se aplica a sus sitios web, aplicaciones móviles u otros contenidos. Fiserv no
                    garantiza,
                    aprueba ni avala ninguna información, material, servicios o productos incluidos o disponibles a
                    través de
                    cualquier sitio web, aplicación móvil u otro contenido de terceros conectado por vínculo. Fiserv no
                    es
                    responsable de ningún contenido en propiedades de terceros con las que nos vinculamos. Fiserv
                    proporciona
                    vínculos a propiedades o contenidos de terceros para su comodidad, y el riesgo de visitar o usar
                    contenidos o
                    propiedades de terceros vinculados corre por su cuenta.
                    <br><br>
                    <b>
                        8. Información adicional para usuarios europeos
                    </b>
                    <br><br>
                    <b>
                        Controlador y encargado de la protección de datos
                    </b>
                    <br><br>
                    Fiserv está conformada por distintas entidades legales. Las referencias a "Fiserv", "nosotros",
                    "nos" o "nuestro"
                    en este Aviso de privacidad deben leerse para referirse a la empresa relevante en el grupo de Fiserv
                    responsable del manejo de sus datos. Le avisaremos qué miembro del Grupo de Fiserv será el
                    controlador de
                    sus datos. Esa información se proporcionará en el contrato que firmemos con usted o en un aviso de
                    privacidad
                    que proporcionaremos que se refiere específicamente a la relación que tenemos con usted.
                    Hemos designado a un encargado de la protección de datos (Data Protection Officer, “DPO”) que es
                    responsable
                    de supervisar las preguntas relacionadas con este Aviso de privacidad. Si tiene alguna pregunta
                    acerca de este
                    Aviso de privacidad, incluida cualquier solicitud para ejercer sus derechos legales, comuníquese con
                    el DPO a
                    través de los detalles indicados a continuación:
                    <br><br>
                    Encargado de la Protección de Datos, Fiserv<br>
                    Dirección de correo electrónico: dpo@firstdata.com<br>
                    Dirección postal: Janus House<br>
                    Endeavour<br>
                    Basildon<br>
                    Essex SS14 3WF<br>
                    <br><br>
                    <b>
                        Bases legales para el procesamiento
                    </b>
                    <br><br>
                    Estamos obligados a informarle las bases legales de nuestro procesamiento de sus datos personales,
                    las cuales
                    se describen en la tabla a continuación. Si tiene preguntas sobre la base legal de cómo procesamos
                    sus datos
                    personales, contáctenos.
                    <br><br>
                    <table style="border-collapse: collapse; width: 100%;">
                        <tr>
                            <td style="border: 1px solid black; padding: 10px;">
                                <b>Fin de procesamiento </b>
                                Los detalles sobre cada fin de procesamiento
                                que se enumera a continuación se proporcionan
                                en la sección anterior titulada “Cómo usamos
                                sus datos personales”.
                            </td>
                            <td style="border: 1px solid black; padding: 10px;"><b>Base legal</b>
                            </td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid black; padding: 10px;">Proporcionar nuestros productos y
                                servicios</td>
                            <td style="border: 1px solid black; padding: 10px;">El procesamiento es necesario para
                                desempeñar el contrato que rige nuestra
                                provisión de los productos o servicios o para
                                tomar las medidas que usted solicite antes de
                                inscribirse en los servicios.</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid black; padding: 10px;">
                                <ul>
                                    <li>
                                        Marketing
                                    </li>
                                    <li>
                                        Para fines de investigación y desarrollo
                                    </li>
                                    <li>
                                        Para gestionar nuestro reclutamiento y
                                        procesar las solicitudes de empleo
                                    </li>
                                    <li>
                                        Para fines de cumplimiento, prevención del
                                        fraude y seguridad
                                    </li>
                                    <li>
                                        Para crear datos anónimos
                                    </li>
                                </ul>
                            </td>
                            <td style="border: 1px solid black; padding: 10px;">Estas actividades de procesamiento
                                constituyen nuestros intereses legítimos. Nos
                                aseguramos de considerar y equilibrar
                                cualquier impacto potencial sobre usted (tanto
                                positivo como negativo) y sus derechos antes
                                de procesar sus datos personales para
                                nuestros intereses legítimos. No usamos sus
                                datos personales para actividades en las que
                                nuestros intereses sean anulados por el
                                impacto sobre usted (a menos que tengamos su
                                consentimiento o que de otro modo lo exija o
                                permita la ley).</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid black; padding: 10px;">Para cumplir con la ley</td>
                            <td style="border: 1px solid black; padding: 10px;">El procesamiento es necesario para
                                cumplir con
                                nuestras obligaciones legales</td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid black; padding: 10px;">Con su consentimiento</td>
                            <td style="border: 1px solid black; padding: 10px;">El procesamiento se basa en su
                                consentimiento. Cuando dependemos de su
                                consentimiento, usted tiene el derecho de
                                retirarlo en cualquier momento de la manera
                                indicada en el momento en que recopilemos su
                                información o comunicándose con nosotros por
                                correo electrónico a<u>dpo@firstdata.com</u>. </td>
                        </tr>
                    </table>
                    <br><br>
                    <b>
                        Uso para nuevos fines
                    </b>
                    <br><br>
                    Podemos utilizar sus datos personales por motivos que no se describen en este Aviso de privacidad
                    cuando lo
                    permita la ley y la razón es compatible con el fin para el que la recopilamos.
                    <br><br>
                    <b>
                        Decisiones automatizadas, sociedades de información crediticia y agencias de prevención de
                        fraude
                    </b>
                    <br><br>
                    A veces, tomamos decisiones automatizadas sobre la base de sus datos personales (ya sea que usted
                    los
                    proporcione o que nosotros los obtengamos de terceros, como sociedades de información crediticia y
                    agencias
                    de prevención de fraude. Solo haremos esto cuando sea necesario en relación con un contrato, o lo
                    autorice la
                    ley, o en base a su consentimiento explícito. Puede comunicarse con nosotros para obtener más
                    información
                    sobre la toma de decisiones automatizadas. Consulte también la sección “Sus derechos legales
                    individuales” a
                    continuación.
                    <br><br>
                    <b>
                        ¿Durante cuánto tiempo usarán mis datos personales?
                    </b>
                    <br><br>
                    Usaremos sus datos personales durante el tiempo que sea necesario sobre la base del motivo por el
                    cual lo
                    recopilamos y para qué lo usamos. Esto puede incluir nuestra necesidad de cumplir con un requisito
                    legal,
                    reglamentario, contable o de presentación de informes.
                    <br><br>
                    Para determinar el período de retención adecuado de los datos personales, tenemos en cuenta la
                    cantidad, la
                    naturaleza y la privacidad de los datos personales, el potencial riesgo de daños debido al uso o la
                    divulgación
                    no autorizados de sus datos personales, los propósitos por los que procesamos sus datos personales y
                    si
                    podemos lograr esos propósitos a través de otros medios, y los requisitos legales aplicables.
                    <br><br>
                    En general, conservaremos sus datos personales durante toda su relación/compromiso con nosotros y
                    durante
                    el tiempo que sea razonablemente necesario posteriormente; sin embargo, es posible que mantengamos
                    diferentes períodos de retención para diferentes productos y servicios. Además, hay ciertos tipos de
                    información
                    que la ley nos exige conservar durante determinado período.
                    <br><br>
                    <b>
                        Sus derechos legales individuales
                    </b>
                    <br><br>
                    En determinadas circunstancias, las personas en Europa tienen derechos en el marco de las leyes de
                    protección
                    de datos relativos a sus datos personales. Si se encuentra en Europa, puede pedirnos que tomemos las
                    siguientes medidas con respecto a los datos personales que mantenemos:
                    <br><br>
                    <ul>
                        <li>
                            <b>Acceso</b>. Usted tiene derecho a preguntarnos si estamos procesando sus datos personales
                            y, en ese
                            caso, pedirnos una copia de los datos personales que mantenemos sobre usted, así como a
                            obtener
                            otra información sobre nuestras actividades de procesamiento.

                        </li>
                        <li>
                            <b>Corrección</b>. Si algún dato personal que tenemos sobre usted está incompleto o es
                            impreciso, puede
                            pedirnos que lo corrijamos, no obstante, es posible que debamos verificar la precisión de
                            los nuevos
                            datos que nos proporcione.
                        </li>
                        <li>
                            <b>Eliminación</b>. Esto le permite pedirnos que eliminemos o quitemos datos personales si
                            no existe una
                            buena razón para que los sigamos procesando. También tiene derecho a pedirnos que eliminemos
                            o
                            quitemos sus datos personales cuando haya ejercido exitosamente su derecho objetar el
                            procesamiento
                            (vea debajo), cuando es posible que nosotros hayamos procesado su información de manera
                            ilegal, o
                            cuando debamos eliminar sus datos personales para cumplir con la ley local.
                        </li>
                        <li>
                            <b>Objeción</b>. Si nuestra razón para procesar sus datos personales se debe a un interés
                            legítimo, usted
                            puede oponerse al procesamiento si considera que afecta sus derechos y libertades
                            fundamentales.
                            También tiene derecho a objetar si procesamos sus datos personales por propósitos de
                            marketing
                            directo.
                        </li>
                        <li>
                            <b>Restricción</b>. Puede pedirnos que suspendamos nuestro uso de sus datos personales en
                            las siguientes
                            situaciones:
                            <br><br>
                            <ul>
                                <li>
                                    Si desea que determinemos la precisión de los datos.
                                </li>
                                <li>
                                    Si nuestro uso de sus datos personales es ilegal pero no quiere que los eliminemos.
                                </li>
                                <li>
                                    Si necesita que conservemos sus datos durante un período más prolongado del
                                    habitual, porque
                                    los necesita para establecer, ejercer o defender demandas legales.
                                </li>
                                <li>
                                    Si se ha opuesto a nuestro uso de sus datos pero necesitamos verificar si tenemos
                                    motivos
                                    legítimos primordiales para usarlos.
                                </li>
                            </ul>

                        </li>
                        <li>
                            <b>Transferencia</b>. Cuando sea posible, le proporcionaremos a usted, o a un tercero que
                            haya elegido, sus
                            datos personales en un formato estructurado, que se utilice generalmente y legible por
                            máquina. Tenga
                            en cuenta que este derecho solo se aplica a los datos personales proporcionados por usted de
                            los cuales
                            nos haya dado su consentimiento inicialmente para que los usemos, o si usamos la información
                            para
                            entablar un contrato con usted.

                        </li>
                        <li>
                            <b>Retiro</b> del consentimiento. Cuando nuestro motivo para el procesamiento se basa en su
                            consentimiento, usted puede retirar ese consentimiento en cualquier momento. Si retira su
                            consentimiento, es posible que no podamos brindarle determinados productos o servicios. Le
                            informaremos si este es el caso en el momento que retire su consentimiento.
                        </li>
                        <li>
                            <b>Toma de decisiones automatizadas</b>. Tiene el derecho a no estar sujeto a la toma de
                            decisiones
                            automatizadas (p. ej., elaboración de perfiles) que lo afecten significativamente. El
                            ejercicio de este
                            derecho no está disponible en los siguientes casos:
                            <br><br>
                            <ul>
                                <li>
                                    La decisión automatizada se requiere para celebrar, o entablar, un contrato con
                                    usted
                                </li>
                                <li>
                                    Tenemos su consentimiento explícito para tomar dicha decisión.
                                </li>
                                <li>
                                    La decisión automatizada está autorizada por la ley local de un estado miembro de la
                                    Unión
                                    Europea.
                                </li>
                                <br>
                                Sin embargo, en los dos primeros casos expuestos anteriormente, tiene derecho a
                                solicitar la
                                intervención humana con respecto a la decisión, a expresar su punto de vista y a
                                impugnar la
                                decisión.
                            </ul>
                        </li>
                    </ul>
                    Puede enviar solicitudes para ejercer estos derechos enviando un correo electrónico al DPO de Fiserv
                    a
                    <u>dpo@firstdata.com</u>. Es posible que debamos solicitarle información específica para que nos
                    ayude a confirmar
                    su identidad y para asegurarnos de que esté autorizado a ejercer un derecho con respecto a sus datos
                    personales, por ejemplo, un número de identificación de cliente o un número de cuenta. Esta es una
                    medida de
                    seguridad para garantizar que sus datos personales no se divulguen a ninguna persona que no tenga
                    derecho
                    a recibirlos. También podemos comunicarnos con usted para pedirle más información en relación con su
                    solicitud de acelerar nuestra respuesta.
                    <br><br>
                    Pueden existir motivos legales o de otro tipo por los que no podamos, o no tengamos la obligación
                    de, satisfacer
                    una solicitud para ejercer sus derechos. En la medida de lo posible, usaremos las exenciones legales
                    disponibles a sus derechos individuales. Si rechazamos su solicitud, le contaremos por qué, sujeto a
                    restricciones legales.
                    <br><br>
                    No deberá pagar ninguna tarifa para ejercer cualquiera de sus derechos relacionados con sus datos
                    personales.
                    Sin embargo, podemos cobrar una tarifa razonable si su solicitud es claramente infundada, repetitiva
                    o excesiva.
                    Como alternativa, podemos negarnos a cumplir con su solicitud en estas circunstancias.
                    <br><br>
                    Responderemos a todas las solicitudes legítimas con prontitud y, en todo caso, dentro de los plazos
                    establecidos
                    por las leyes locales. En general, debemos responder a las consultas en el plazo de un mes a partir
                    de la
                    recepción de la solicitud, por lo tanto, es importante que las solicitudes se identifiquen y se
                    envíen a
                    dpo@firstdata.com lo antes posible. En ocasiones, puede llevarnos más de un mes si su solicitud es
                    particularmente compleja o si ha realizado varias solicitudes. En este caso, le avisaremos y lo
                    mantendremos
                    actualizado. Cualquier transmisión de sus datos personales se realizará de manera segura.
                    <br><br>
                    Usted también tiene derecho a presentar una queja en cualquier momento a una autoridad de
                    supervisión (para
                    obtener más información, visite <b><a style="color: black !important;"
                            href=" https://edpb.europa.eu/about-edpb/board/members_en)" target="_blank">
                            https://edpb.europa.eu/about-edpb/board/members_en)
                        </a></b>.
                    <br><br>
                    <b>
                        Transferencia internacional de datos
                    </b>
                    <br><br>
                    Transferimos sus datos personales dentro del grupo de Fiserv, incluso fuera de Europa. Cada vez que
                    transferimos sus datos personales fuera de Europa dentro del grupo de Fiserv a países que la
                    Comisión Europea
                    considera que no proporcionan un nivel adecuado de protección de datos personales, la transferencia
                    se basará
                    en nuestras Normas corporativas vinculantes, cuya copia puede encontrarse aquí. FDR Limited es la
                    entidad
                    de Fiserv responsable del cumplimiento de las Normas corporativas vinculantes de Fiserv.
                    <br><br>
                    Cuando transferimos datos personales fuera de Europa a terceros en países que la Comisión Europea
                    considera
                    que no proporcionan un nivel adecuado de protección de datos personales, la transferencia se
                    realizará de
                    conformidad con:
                    <ul>
                        <li>
                            un contrato aprobado por la Comisión Europea (a veces denominado “Cláusulas Modelo” o
                            “Cláusulas
                            Contractuales Estándar”);

                        </li>
                        <li>
                            el Escudo de Privacidad entre la UE y los EE. UU.;
                        </li>
                        <li>
                            las Normas corporativas vinculantes del destinatario;
                        </li>
                        <li>
                            el consentimiento de la persona a la que se relacionan los datos personales; o
                        </li>
                        <li>
                            otros mecanismos o fundamentos jurídicos que puedan permitirse en virtud de la legislación
                            europea
                            aplicable.
                        </li>
                    </ul>
                    <br><br>
                    Comuníquese con nosotros si desea recibir más información sobre el mecanismo específico que
                    utilizamos al
                    transferir sus datos personales fuera de Europa.
                    <br><br>
                    <b>
                        9. Cambios a este Aviso de privacidad
                    </b>
                    <br><br>
                    Nos reservamos el derecho de modificar este Aviso de privacidad en cualquier momento. Le
                    recomendamos
                    que revise periódicamente esta página para obtener la información más reciente sobre nuestras
                    prácticas de
                    privacidad. Si realizamos cambios sustanciales a este Aviso de privacidad, le notificaremos mediante
                    la
                    actualización de la fecha de este Aviso de privacidad y la publicación de estos cambios en nuestro
                    sitio web y
                    en las tiendas de aplicaciones donde puede descargar nuestras aplicaciones móviles cubiertas por
                    este Aviso
                    de privacidad. También (y, según lo exija la ley) podemos notificarle los cambios de otra manera que
                    creamos
                    que, de manera razonable, probablemente le llegue, por ejemplo, mediante correo electrónico (si
                    posee una
                    cuenta donde tengamos su información de contacto) o, de otra manera, a través de nuestro sitio web o
                    aplicaciones móviles.<br><br>
                    Cualquier modificación a este Aviso de privacidad entrará en vigencia tras nuestra publicación de
                    los nuevos
                    términos o tras la implementación de los nuevos cambios (o, según se indique de otro modo, en el
                    momento de
                    la publicación). En todos los casos, su uso continuo de nuestros productos o servicios tras la
                    publicación de
                    cualquier Aviso de privacidad modificado indica que acepta los términos del Aviso de privacidad
                    modificado.
                    <br><br>
                    <b>
                        10. Contáctenos
                    </b>
                    <br><br>
                    Si tiene alguna pregunta, inquietud o queja sobre este Aviso de privacidad o nuestras prácticas de
                    privacidad,
                    o para solicitar acceso a sus datos personales, puede comunicarse con nuestro encargado de la
                    protección de
                    datos enviando un correo electrónico a dpo@firstdata.com. La información de contacto para una región
                    en
                    particular también está disponible a solicitud.<br><br>
                    También mantenemos una línea directa de privacidad de datos, que está disponible las 24 horas del
                    día desde
                    los Estados Unidos, llamando al <b>+1 800-368-1000</b>. La línea directa es el contacto más adecuado
                    para una
                    inquietud urgente, por ejemplo, para informar una sospecha de violación de datos con respecto a sus
                    datos
                    personales; o, si usted es un comerciante, datos de sus clientes.<br><br>
                    Para preguntas sobre su tarjeta de crédito o de débito, o su compra, comuníquese con la institución
                    financiera
                    que emitió su tarjeta o el comerciante.
                </span>
            </div>

        </div>

    </div>
</div>
<app-new-footer></app-new-footer>